import React from "react";
import ContactForm from "../components/ContactForm";
import TopBar from "../components/TopBar";
import ServicesCard from "../components/ServicesCard";
import TeamCard from "../components/TeamCard";
import Footer from "../components/Footer";
import hygeineIcon from "../images/bubbles.png";
import brushIcon from "../images/brush-cleaning.png";
import calendarIcon from "../images/calendar-check.png";
import hamburgerIcon from "../images/hamburger.png";
import heartIcon from "../images/heart-plus.png";
import moonIcon from "../images/moon-star.png";
import shirtIcon from "../images/shirt.png";
import healthcareImage from "../images/senior_hand_hold.jpg";
import elderImage from "../images/elderly-care.jpg";
import "../App.css";

function Services() {
   const services = [
  {
    name: "Memory Care Services",
    role: "Specialized care for those with memory-related conditions.",
    description: [
      "Cognitive stimulation activities",
      "Memory exercises",
      "Safe environment monitoring",
      "Routine maintenance",
      "Wandering prevention",
      "Family communication and updates",
      "Medication management"
    ],
    icon: heartIcon
  },
  {
    name: "Hygiene Care Services",
    role: "Personal hygiene with comfort and dignity in mind.",
    description: [
      "Assistance with showering and bathing",
      "Hair washing and care",
      "Oral hygiene assistance",
      "Foot care and maintenance",
      "Bedding changes and care"
    ],
    icon: hygeineIcon
  },
  {
    name: "Grooming Care Services",
    role: "Helping you look and feel your very best every day.",
    description: [
      "Outfit selection and coordination",
      "Dressing assistance",
      "Hair styling and grooming",
      "Skincare assistance"
    ],
    icon: shirtIcon
  },
  {
    name: "Meal Care Services",
    role: "Nutritious meals prepared with care and companionship.",
    description: [
      "Personalized meal planning",
      "Grocery shopping assistance",
      "Meal preparation",
      "Eating assistance",
      "Custom cooking",
      "Kitchen cleanup and organization"
    ],
    icon: hamburgerIcon
  },
  {
    name: "Health Care Services",
    role: "Supporting health and wellness with attentive assistance.",
    description: [
      "Medication reminders and monitoring",
      "Medication organization and management",
      "Detailed medication administration records",
      "Safe mobility assistance",
      "Physical therapy exercise support",
      "Medical appointment accompaniment"
    ],
    icon: heartIcon
  },
  {
    name: "Light Housekeeping Care Services",
    role: "Keeping your home tidy, safe, and comfortable.",
    description: [
      "Making beds",
      "Cleaning bathrooms",
      "Sweeping and mopping floors",
      "Managing trash and recycling",
      "Handling laundry",
      "Organizing mail, bills, and documents"
    ],
    icon: brushIcon
  },
  {
    name: "Throughout the Day Care Service",
    role: "Compassionate support for daily needs and activities.",
    description: [
      "Toileting and personal care assistance",
      "Hydration monitoring and support",
      "Regular vital signs monitoring",
      "Gentle exercise guidance",
      "Engaging activities and games",
      "Meaningful conversation and companionship",
      "Technology guidance and support",
      "Dedicated companionship care"
    ],
    icon: calendarIcon
  },
  {
    name: "Live-in / Overnight Care Service",
    role: "Around-the-clock care for safety, comfort, and peace.",
    description: [
      "Regular safety monitoring",
      "Nutritious snack preparation",
      "Snack and meal assistance",
      "Hydration management",
      "Health monitoring and documentation",
      "Safe nighttime mobility assistance",
      "Overnight companionship",
      "24/7 emergency response"
    ],
    icon: moonIcon
  },
];

const carePoints = [
  {
    header: "1. Personalized Care Planning",
    subtitle: "We work with you to create an individualized care plan tailored to your unique needs."
  },
  {
    header: "2. Ongoing Monitoring",
    subtitle: "We regularly track and review your care and service plans to ensure the best outcomes."
  },
  {
    header: "3. Round-the-Clock Support",
    subtitle: "Our dedicated team provides 24/7 assistance for safety, comfort, and peace of mind."
  },
  {
    header: "4. Transparent Communication",
    subtitle: "We maintain open dialogue with you and your loved ones for clarity and trust."
  }
];

  return (
    <div className="App">
    <TopBar />
    <div className="App-header-services">
       <div className="hero-text-left">
          <h1 className="hero-title">Our Services</h1>
          <p className="hero-subtitle-2">
Our mission is to assist you to recruit the right care giver for you to make life safe,
comfortable, and meaningful every day. We take the time to understand your family’s
unique needs and concerns. From there, we collaborate with you to design a
personalized care plan that truly fits your situation. Each client is carefully matched with
a caregiver who feels like the right fit.        
        </p>
        </div>
      <div className="service-cards-grid">
        {services.map((service, index) => (
            <ServicesCard
              key={index}
              name={service.name}
              role={service.role}
              services={service.description}
              icon={service.icon}
            />
          ))}
      </div>

     </div>
      <div className="App care-section">
        <div className="Service-2-page">
          <div className="hero-text">
            <h1 className="service-title-2">How We Care For You</h1>
            <div className="services-how-we-care-cards">
              {carePoints.map((reasons, index) => (
                <TeamCard
                  key={index}
                  name={reasons.header}
                  description={reasons.subtitle}
                />
              ))}
            </div>
          </div>
          <img src={elderImage} alt="Health care" className="services-image" />
        </div>


      </div>        
  <ContactForm />
  <Footer />
    </div>
  );
}

export default Services;
